import { render, staticRenderFns } from "./Duesa.vue?vue&type=template&id=dd55b850&scoped=true&"
import script from "./Duesa.vue?vue&type=script&lang=js&"
export * from "./Duesa.vue?vue&type=script&lang=js&"
import style0 from "./Duesa.vue?vue&type=style&index=0&id=dd55b850&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd55b850",
  null
  
)

export default component.exports